import gql from 'graphql-tag'
import { main } from './fragments'

export default gql`
	mutation updateLoyaltyCard($id: ID! $fields: LoyaltyCardFields) {
		cashAssist {
			updateLoyaltyCard(id: $id fields: $fields) {
				id
				...loyaltyCardMain
			}
		}
	}
	${main}
`
